// AppInitializer.jsx
import React, { useEffect, useState } from 'react';
import AppLoaderPage from './AppLoaderPage';
import SystemRoutes from '../../Nav/SystemRoutes';
import { useAuth } from '../../DataStore/AuthContext';

const AppInitializer = () => {
  const { getProfiles, getMyProfile, user } = useAuth();
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const bootApp = async () => {
      try {
        await getProfiles();
        await getMyProfile();
      } finally {
        setInitializing(false);
      }
    };

    bootApp();
  }, []);

  if (initializing) {
    return <AppLoaderPage />;
  }

  

  return <SystemRoutes />;
};

export default AppInitializer;
